import axios from "axios";
import { PRIL_CUSTOMER_ENDPOINT, PRIL_ENDPOINT, PRIL_COMPANY_ENDPOINT } from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import AddPRILPayload from "@/dto/request/pril/AddPRILPayload";
import PRIL_DTO from "@/dto/request/pril/PRIL_DTO";
import QueryUtils from "@/utils/QueryUtils";
import PRILFilter from "@/dto/request/pril/PRILFilter";
import EditPRILPayload from "@/dto/request/pril/EditPRILPayload";
import AddPRILCommentPayload from "@/dto/request/pril/AddPRILCommentPayload";
import AddPRILAdditionalFilePayload from "@/dto/request/pril/AddPRILAdditionalFilePayload";
import Page from "@/dto/taxation/Page";
import Short_PRIL_DTO from "@/dto/request/pril/Short_PRIL_DTO";
import { PRILStatus } from "@/constants/request/PRILConstants";

class PRILService {
  getLetterById(id: number) {
    return axios.get<PRIL_DTO>(`${PRIL_ENDPOINT}/${id}`, {headers: authHeader()})
  }

  getLettersByCustomerId(id: number, filter: { pageNumber: number, pageSize: number }) {
    const query = QueryUtils.objectToQueryString(filter);
    return axios.get<Page<Short_PRIL_DTO>>(`${PRIL_CUSTOMER_ENDPOINT}/${id}${query}`, {headers: authHeader()})
  }

  getLettersByFilter(filter: PRILFilter) {
    const queryString = QueryUtils.objectToQueryString(filter);
    return axios.get<Page<PRIL_DTO>>(`${PRIL_ENDPOINT}${queryString}`, {headers: authHeader()})
  }

  addLetter(payload: AddPRILPayload) {
    return axios.post(PRIL_ENDPOINT, payload, {headers: authHeader()})
  }

  addComment(id: number, payload: AddPRILCommentPayload) {
    const queryString = QueryUtils.objectToQueryString(payload);
    return axios.post(`${PRIL_ENDPOINT}/${id}/comments${queryString}`, payload, {headers: authHeader()})
  }

  updateLetter(id: number, payload: EditPRILPayload) {
    return axios.put(`${PRIL_ENDPOINT}/${id}`, payload, {headers: authHeader()})
  }

  updateLetterStatus(id: number, status: PRILStatus) {
    return axios.put(`${PRIL_ENDPOINT}/${id}/status/${status}`,{}, {headers: authHeader()})
  }

  assign(id: number, newAssigneeId: number) {
    return axios.put(`${PRIL_ENDPOINT}/${id}/assignee`, {value: newAssigneeId}, {headers: authHeader()});
  }

  addAdditionalFile(id: number, payload: AddPRILAdditionalFilePayload) {
    return axios.post(`${PRIL_ENDPOINT}/${id}/additional-files`, payload, {headers: authHeader()});
  }

  changeCompany(id: number, companyId: number) {
    return axios.put(PRIL_COMPANY_ENDPOINT.replace('{id}', `${id}`), {value: companyId}, {headers: authHeader()});
  }
}

export default new PRILService();
